import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './InfoTooltip.module.scss';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import Modal from '../../../../components/Modal';
import ReactDOM from "react-dom";

const TOOLTIP_MAX_WIDTH = 450;
const TOP_MARGIN = 30;

const InfoTooltip = ({ text, icon = null, fixedPosition = false, containerRef = null, position = 'middle' }) => {
  const [isHover, setIsHover] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const tooltipContainerRef = useRef(null);
  const [style, setStyle] = useState(null);

  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isMobile = isMobileView || isTouchDevice;

  const iconComponent = useMemo(() => {
    if (React.isValidElement(icon)) {
      const handlers = {
        onMouseOver: () => !isMobile && setIsHover(true),
        onMouseLeave: () => !isMobile && setIsHover(false)
      };

      if (isMobile) {
        handlers.onClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDialogOpen(true);
        };
      }

      return React.cloneElement(icon, handlers);
    }
    return null;
  }, [icon, isMobile])

  useEffect(() => {
    if (fixedPosition) {
      if (isHover) {
        const { left, top } = tooltipContainerRef.current.getBoundingClientRect();
        let offset = 0;
        if (left + TOOLTIP_MAX_WIDTH / 2 > innerWidth) {
          offset = TOOLTIP_MAX_WIDTH / 2;
        }
        setStyle({ zIndex: 999, position: 'fixed', opacity: 0, left: left - offset, top: top + TOP_MARGIN, transform: 'translateX(-50%)', transition: 'all 50ms ease-in-out, opacity: 150ms easy-in-out' });

        setTimeout(() => {
          setStyle(prevState => ({ ...prevState, opacity: 1 }));
        }, 100);
      } else {
        setStyle(prevState => ({ ...prevState, opacity: 0 }));
      }
    }
  }, [isHover])

  useEffect(() => {
    if (fixedPosition) {
      window.addEventListener('scroll', () => {
        setIsHover(false);
      });
    }
    return () => {
      window.removeEventListener('scroll', () => {
        setIsHover(false);
      });
    }
  }, [])

  const handleIconClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();
      setIsDialogOpen(true);
    }
  };

  const handleIconMouseOver = () => {
    if (!isMobile) {
      setIsHover(true);
    }
  };

  const handleIconMouseLeave = () => {
    if (!isMobile) {
      setIsHover(false);
    }
  };

  return (
    <>
      <div className={styles.container} ref={tooltipContainerRef}>
        {iconComponent ? iconComponent : (
          <div
            className={styles.iconWrapper}
            onMouseOver={handleIconMouseOver}
            onMouseLeave={handleIconMouseLeave}
            onClick={handleIconClick}
          >
            <span className={styles.iconText}>i</span>
          </div>
        )}
        {!isMobile && isHover && containerRef?.current?.parentNode && ReactDOM.createPortal(
          <Tooltip text={text} isHover={isHover} classNameTooltip={styles.infoContainer} position={position} moveable={false} topPosition={25} tooltipStyle={style} />,
          containerRef?.current?.parentNode ?? document.body
        )}
        {!isMobile && !containerRef?.current?.parentNode && <Tooltip text={text} isHover={isHover} classNameTooltip={styles.infoContainer} position={position} moveable={false} topPosition={25} tooltipStyle={style} />}
      </div>
      <Modal
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        className={styles.dialogModal}
        closeOnEsc={true}
      >
        <div className={styles.dialogContent}>
          {text}
        </div>
      </Modal>
    </>
  );
};

export default InfoTooltip;
